import React from 'react';
import {
  Autocomplete,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import DisponibilitePicker from '../../commun/DisponibilitePicker';
import { disponibiliteOptions, RoleOptions } from '../../commun/constants/options';
import './Addmission.css';

const StepThree = ({ data, errors, onChange, users = [] }) => {
  const handleUserChange = (event, user) => {
    if (user) {
      onChange('nom', user.nom);
      onChange('email', user.email);
      onChange('telephone', user.telephone);
    } else {
      onChange('nom', '');
      onChange('email', '');
      onChange('telephone', '');
    }
  };

  const handleNumericChange = (field, value) => {
    const numericValue = value.replace(/\D/g, '');
    onChange(field, numericValue);
  };
  const filteredOptions = disponibiliteOptions.filter(opt => opt.value !== 'immédiat');

  return (
    <form className="step-three-container">

      {/* Sélection du responsable */}
      <Autocomplete
        options={users}
        getOptionLabel={option =>
          option.nom ? `${option.nom} (${option.email})` : ''
        }
        value={users.find(u => u.email === data.email && u.nom === data.nom) || null}
        onChange={handleUserChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Responsable "
            required
            error={!!errors.nom}
            helperText={errors.nom}
            className="step-three-half"
          />
        )}
        isOptionEqualToValue={(option, value) =>
          option.email === value.email
        }
        noOptionsText="Aucun utilisateur trouvé"
      />

      {/* Affichage auto du mail/tel */}
      <TextField
        label="Email responsable"
        required
        value={data.email}
        error={!!errors.email}
        helperText={errors.email}
        className="step-three-half"
        type="email"
        InputProps={{ readOnly: true }}
      />

      <TextField
        label="Téléphone"
        required
        value={data.telephone}
        error={!!errors.telephone}
        helperText={errors.telephone}
        className="step-three-half"
        InputProps={{ readOnly: true }}
      />

      <FormControl error={!!errors.role} required>
        <InputLabel>Rôle</InputLabel>
        <Select
          value={data.role}
          label="Rôle"
          onChange={(e) => onChange('role', e.target.value)}
        >
          {RoleOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <DisponibilitePicker
        label="Date limite"
        value={data.dateLimite}
        onChange={(val) => onChange('dateLimite', val)}
        error={!!errors.dateLimite}
        helperText={errors.dateLimite}
        required
        options={filteredOptions}
      />

      <TextField
        label="Profil(s) recherché(s)"
        required
        value={data.placesDispo}
        onChange={(e) => handleNumericChange('placesDispo', e.target.value)}
        error={!!errors.placesDispo}
        helperText={errors.placesDispo}
        className="step-three-half"
        type="number"
        inputProps={{ min: 0 }}
      />
    </form>
  );
};

export default StepThree;
